import { useContext } from "react";
import { IconButton, Table, TableBody, TableCell, TableFooter, TableHead, TablePagination, TableRow, Tooltip, Zoom } from "@mui/material";
import { customerUsersContext } from '../CustomerUsersContext';
import { useIntl } from "react-intl";
import { LocalizationIds } from "helpers/Localizations";
import { DeleteIconButton, EditIconButton, LanguageLabel } from "components";
import { BiMailSend as ResendEmailIcon } from 'react-icons/bi';
import Moment from "react-moment";

let Results = () => {
    let { formatMessage } = useIntl();
    let service = useContext(customerUsersContext);

    return (
        <>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell>{formatMessage({ id: LocalizationIds.Name })}</TableCell>
                        <TableCell>{formatMessage({ id: LocalizationIds.Email })}</TableCell>
                        <TableCell>{formatMessage({ id: LocalizationIds.Language })}</TableCell>
                        <TableCell>{formatMessage({ id: LocalizationIds.CreatedOn })}</TableCell>
                        <TableCell></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {service.users.map((user, index) =>
                        <TableRow hover key={index}>
                            <TableCell>{user.fullName}</TableCell>
                            <TableCell>{user.email}</TableCell>
                            <TableCell><LanguageLabel value={user.language} /></TableCell>
                            <TableCell>
                                <Moment date={user.createdOn} format="LL" />
                            </TableCell>
                            <TableCell align="right">
                                <EditIconButton link={`/customer/user/edit/${user.id}`} />
                                <Tooltip title={formatMessage({ id: LocalizationIds.ResendEmailInvitation })} TransitionComponent={Zoom}>
                                    <IconButton
                                        size="small"
                                        color="secondary"
                                        onClick={async (ev) => {
                                            ev.stopPropagation();
                                            await service.reSendEmail(user.id);
                                        }}
                                    >
                                        <ResendEmailIcon />
                                    </IconButton>
                                </Tooltip>
                                <DeleteIconButton onClick={() => service.deleteUser(user.id)} />
                            </TableCell>
                        </TableRow>
                    )}
                </TableBody>
                {service.recordCount === 0 &&
                    <TableFooter>
                        <TableRow>
                            <TableCell colSpan={4}><i>{formatMessage({ id: LocalizationIds.NoUsersFound })}</i></TableCell>
                        </TableRow>
                    </TableFooter>
                }
            </Table>
            <TablePagination
                component="div"
                count={service.recordCount}
                onPageChange={(e, pageNr) => service.handleChangePage(pageNr)}
                page={service.search.pageNr}
                rowsPerPage={service.search.pageSize}
                rowsPerPageOptions={[service.search.pageSize]}
                labelDisplayedRows={({ page, count }) =>
                    <>
                        {formatMessage({ id: LocalizationIds.TotalUsers })}:&nbsp;{count} &nbsp;&middot;&nbsp;
                        <span>
                            {formatMessage(
                                { id: LocalizationIds.PageOf },
                                { pageNr: page + 1, count: Math.ceil(count / service.search.pageSize) }
                            )}
                        </span>
                    </>
                }
            />
        </>
    )
}

export default Results;